import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Zichtbaar buildnummer + nieuwe-versie-melding (wens Tom 24-09: hij testte
 * onbewust een oude versie en dacht dat gevraagde fixes niet gebouwd waren).
 * Rechtsonder, onopvallend: "build <id>". Zodra /version.json (geschreven bij
 * elke deploy) een nieuwere build meldt, wordt het een knop "Nieuwe versie —
 * ververs" die de pagina herlaadt. Poll elke 5 min + bij terugkeer naar het
 * tabblad; fouten (offline, dev zonder version.json) blijven stil.
 */
const HUIDIG = (import.meta.env.VITE_BUILD_VERSION as string | undefined) ?? '';

export default function VersieBadge() {
  const [nieuweVersie, setNieuweVersie] = useState(false);

  useEffect(() => {
    if (!HUIDIG) return;
    let actief = true;
    const check = async () => {
      try {
        const r = await fetch(`/version.json?nu=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const { version } = (await r.json()) as { version?: string };
        if (actief && version && version !== HUIDIG) setNieuweVersie(true);
      } catch {
        /* stil: offline of dev-server zonder version.json */
      }
    };
    void check();
    const timer = window.setInterval(check, 5 * 60_000);
    const opFocus = () => void check();
    window.addEventListener('focus', opFocus);
    document.addEventListener('visibilitychange', opFocus);
    return () => {
      actief = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', opFocus);
      document.removeEventListener('visibilitychange', opFocus);
    };
  }, []);

  if (!HUIDIG) return null;

  if (nieuweVersie) {
    return (
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="fixed bottom-2 right-2 z-50 flex items-center gap-1.5 rounded-full bg-brand px-3 py-1.5 text-xs font-semibold text-white shadow-lg hover:opacity-90"
        title="Er staat een nieuwere versie van de app klaar — klik om te verversen"
      >
        <RefreshCw className="h-3.5 w-3.5" /> Nieuwe versie — ververs
      </button>
    );
  }

  return (
    <span
      className="pointer-events-none fixed bottom-1 right-2 z-40 select-none text-[10px] tabular-nums text-foreground-tertiary/60"
      title="Buildnummer van de versie die je nu draait"
    >
      build {HUIDIG}
    </span>
  );
}
